import { PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';
import { Icon, ICONS, PLATFORM_THEME_COLORS, Popover } from '@thinknet-gmbh/platform-common-ui';

import { useUserCanManageDocument } from 'src/hooks/user-can-manage-document.hook';
import { TASKS_LIST_MODALS } from '../../tasks-list.constants';
import { ITaskTableItem } from './tasks-list-table.interfaces';

const TasksListRowActions = ({ record, handleModals, t }: {
  record: ITaskTableItem
  handleModals: (modal: string, record: ITaskTableItem) => void,
  t: Function
}) => {
  const { canDelete, canDeleteAll } = useUserCanManageDocument({
    platformPermission: PLATFORM_PERMISSIONS.taskManagement,
    createdBy: record.createdBy,
  });

  const isCanDelete = canDeleteAll || canDelete;

  return (
    <Popover
      elements={[
        {
          label: t('common:buttons.edit'),
          icon: ICONS.editAlt,
          key: ICONS.editAlt,
          handler: () => {
            handleModals(TASKS_LIST_MODALS.edit, record);
          },
        },
        {
          label: t('common:buttons.delete'),
          icon: ICONS.trash,
          color: isCanDelete
            ? PLATFORM_THEME_COLORS.tone.red
            : PLATFORM_THEME_COLORS.grayVariations.murky,

          key: ICONS.trash,
          handler: () => {
            if (isCanDelete) {
              handleModals(TASKS_LIST_MODALS.delete, record);
            }
          },
        },
      ]}
    >
      <Icon
        icon={ICONS.dotsVerticalRounded}
        size={22}
        color={PLATFORM_THEME_COLORS.primary.grey}
        rightMargin={false}
      />
    </Popover>
  );
};

export default TasksListRowActions;
